import { actionCreator } from 'utils';
import * as RollsOutTypes from '../types/rollOutTypes';

// L O A D   R O L L S   O U T
export function loadRollsOut() {
    return {
        type: RollsOutTypes.LOAD_ROLLS_OUT,
    };
}

export function loadRollsOutRes(data) {
    return {
        type: actionCreator(RollsOutTypes.LOAD_ROLLS_OUT, 'res'),
        data,
    };
}

export function loadRollsOutErr() {
    return {
        type: actionCreator(RollsOutTypes.LOAD_ROLLS_OUT, 'err'),
    };
}
// L O A D   R O L L S   O U T

// S E T   R O L L S   O U T   F I L T E R   &   P A G I N A T I O    &   R E S E T
export function setRollOutFilters(key, value) {
    return {
        type: RollsOutTypes.SET_ROLLS_OUT_FILTER,
        key,
        value,
    };
}

export function setRollOutPagination(key, pagination) {
    return {
        type: RollsOutTypes.SET_ROLLS_OUT_PAGINATION,
        key,
        pagination,
    };
}

export function setRollOutSort(key, type) {
    return {
        type: RollsOutTypes.SET_ROLLS_OUT_SORT,
        sort: {
            key,
            type,
        },
    };
}

export function resetRollOutFilters() {
    return {
        type: RollsOutTypes.RESET_ROLLS_OUT_FILTERS,
    };
}
// S E T   R O L L S   O U T   F I L T E R   &   P A G I N A T I O N  &   R E S E T


// T O G G L E   R O L L S   O U T   S T A T U S
export function toggleRollsOutStatus(data) {
    return {
        type: RollsOutTypes.TOGGLE_ROLLS_OUT_STATUS,
        data,
    };
}

export function toggleRollsOutStatusRes() {
    return {
        type: actionCreator(RollsOutTypes.TOGGLE_ROLLS_OUT_STATUS, 'res'),
    };
}

export function toggleRollsOutStatusErr() {
    return {
        type: actionCreator(RollsOutTypes.TOGGLE_ROLLS_OUT_STATUS, 'err'),
    };
}
// T O G G L E   R O L L S   O U T   S T A T U S


// C R E A T E   P A L E T T E   F R O M   R O L L S   O U T
export function createPaletteFromRollsOut(data) {
    return {
        type: RollsOutTypes.CREATE_PALETTE_FROM_ROLLS_OUT,
        data,
    };
}

export function createPaletteFromRollsOutRes() {
    return {
        type: actionCreator(RollsOutTypes.CREATE_PALETTE_FROM_ROLLS_OUT, 'res'),
    };
}

export function createPaletteFromRollsOutErr() {
    return {
        type: actionCreator(RollsOutTypes.CREATE_PALETTE_FROM_ROLLS_OUT, 'err'),
    };
}
// C R E A T E   P A L E T T E   F R O M   R O L L S   O U T
